<template>
  <el-row>
    
    <div class="org_img_block"   @click="handle_click" :class="enabled_class" :style="button_style">
      <svg class="icon icon-item" aria-hidden="true"
           :style="icon_style"
      >
        <use :xlink:href="href"></use>

      </svg>
          <span class="tool-icon-text">{{button_name}}</span>
      <el-divider direction="vertical" content-position="center" v-if="is_line"></el-divider>
    </div>
  </el-row>
</template>

<script>
  export default {
    name: "omnis_button",
    props: {
      enable:{
        type:Boolean,
        default:true
      },
      button_style:{
        type:Object,
        default(){
          return {}
        }
      },
      href: null,
      button_name: null,
      show_title: {
        type: String,
        default: ""
      },
      //是否要竖线
      is_line: {
        type: Boolean,
        default: false
      },

      icon_style:{
        type:Object,
        default(){
          return {}
        }
      }
    },
    computed:{
      enabled_class(){
        let enable = this.enable
        return {
          org_img_block_enable: enable,
          "mask-class": !enable
        }
      }
    },
    methods:{
      handle_click(){
        this.$emit("handle_click", )
      },
             // 选中不选中样式控制
     
    }
  }
</script>

<style scoped>
  .org_img_block {
   /* display: table-cell;*/
    vertical-align: middle;
    text-align: center;
    height:24px;
    padding-left: 8px;
    padding-right: 6px;
    overflow: hidden;
    line-height: 24px;
    -moz-user-select: none;
    /*火狐*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -ms-user-select: none;
    /*IE10*/
    -khtml-user-select: none;
    /*早期浏览器*/
    user-select: none;
   

  }

  .tool-icon-text {
    font-size: 12px;
    color: #585252;
  }

  .org_img_block_enable:hover {
    background: #d5e1f2 !important;
  }

  .org_img_block_enable:active {
    background: #a2bce2 !important;
  }

  .icon-item{
    top: 1px;
    width: 1.1em;
    height: 1.1em;
  }
</style>



// WEBPACK FOOTER //
// omnis_button.vue?042155fe